import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "11",
      height: "16",
      x: "5",
      y: "4",
      rx: "1"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M9 12h13M17 9l5 3-5 3" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }